import apiClient from './api';

export const patientService = {
  getAll: async () => {
    const response = await apiClient.get('/patients');
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/patients/${id}`);
    return response.data;
  },

  create: async (patient) => {
    const response = await apiClient.post('/patients', patient);
    return response.data;
  },

  update: async (id, patient) => {
    const response = await apiClient.put(`/patients/${id}`, patient);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/patients/${id}`);
    return response.data;
  },
};

export const examService = {
  create: async (examData) => {
    const response = await apiClient.post('/exams', examData);
    return response.data;
  },

  getByPatientId: async (patientId) => {
    const response = await apiClient.get(`/patients/${patientId}/exams`);
    return response.data;
  },
};

export const reportService = {
  generateDraft: async (examId) => {
    const response = await apiClient.post(`/reports/generate/${examId}`);
    return response.data;
  },

  getByExamId: async (examId) => {
    const response = await apiClient.get(`/reports/exam/${examId}`);
    return response.data;
  },

  update: async (reportId, reportData) => {
    const response = await apiClient.put(`/reports/${reportId}`, reportData);
    return response.data;
  },

  finalize: async (reportId) => {
    const response = await apiClient.post(`/reports/${reportId}/finalize`);
    return response.data;
  },
};
